module.exports = __webpack_public_path__ + "img/EllipseFill.af63a4a1.svg";